import * as types from "./actionTypes.js";
import * as userApi from '../../api/userApi.js';


export function fetchAuth(code) {
  return function(dispatch) {
    return userApi
      .getAuth(code)
      .then(auth => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_AUTH_SUCCESS,
          auth
        });
      })
      .catch(error => {
        throw error;
      });
  };
}


/**
 * Action that gets the user information from...
 * @param {*} code
 */
export function fetchUserSession(sso) {
  return function(dispatch) {
    return userApi
      .getUserSession(sso)
      .then(user => {
        // separate action creator for successfull api call
        dispatch({
          type: types.FETCH_USER_SESSION_SUCCESS,
          user
        });
      })
      .catch(error => {
        throw error;
      });
  };
};

export function fetchUpdatingUser(userId) {
  return function (dispatch) {
      return userApi
          .getUpdatingUser(userId)
          .then(updatingUser => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.FETCH_UPDATING_USER_SUCCESS,
                  updatingUser
              });
          })
          .catch(error => {
              throw error;
          });
  };
}

export function updateUserHistory(userId) {
  return function (dispatch) {
      return userApi
          .updateUserHistory(userId)
          .then(response => {
              // separate action creator for successfull api call
              dispatch({
                  type: types.UPDATE_USER_HISTORY_SUCCESS,
                  response
              });
          })
          .catch(error => {
              throw error;
          });
  };
}
